import { MouseEventHandler } from 'react';

import useSampleDocumentList from '@app/hooks/documentSetup/useSampleDocumentList';
import UploadFile from '@app/store/documents/UploadFile';

import UploadType from '../UploadType';
import UpLoadModalCloudDrive from './UpLoadModalCloudDrive';
import UpLoadModalDropZone from './UpLoadModalDropZone';
import UpLoadModalSampleDocuments from './UpLoadModalSampleDocuments';

interface UpLoadModalContentProps {
  fileName: string;
  uploadType: UploadType;
  onDrop: (acceptFile: Array<File | UploadFile>) => void;
  onReset: () => void;
  onSelect: MouseEventHandler;
  onSampleDocumentSelect: (documentUrl: string, documentName: string) => void;
}

const defaultProps = {
  fileName: '',
};

function UpLoadModalContent({
  fileName,
  uploadType,
  onReset,
  onDrop,
  onSelect,
  onSampleDocumentSelect,
}: UpLoadModalContentProps) {
  const { data: sampleFileList, isLoading } = useSampleDocumentList();

  if (uploadType === 'LOCAL') {
    return (
      <UpLoadModalDropZone
        fileName={fileName}
        uploadType={uploadType}
        onDrop={onDrop}
        onReset={onReset}
      />
    );
  }
  if (uploadType === 'SAMPLE_DOCUMENTS') {
    return (
      <UpLoadModalSampleDocuments
        isLoading={isLoading}
        sampleFileList={sampleFileList ?? []}
        onSampleDocumentSelect={onSampleDocumentSelect}
        onSelect={onSelect}
      />
    );
  }
  return <UpLoadModalCloudDrive fileName={fileName} onDrop={onDrop} onReset={onReset} />;
}

UpLoadModalContent.defaultProps = defaultProps;

export default UpLoadModalContent;
